import axiosInstance from "./axiosInstance";
import { showAlertError, showAlertExito } from '../utils/alertHelper';

const ventaCocina = 'ventaCocina';

// listando ventas para cocina
export const listVentasCocina = async () => {
    try {
        const response = await axiosInstance.get(`/${ventaCocina}/list`);
        return response.data;
    } catch (error) {
        showAlertError("Error inesperado", "Ocurrió un problema, intenta más tarde.");
    }
};

// crear venta cocina
export const createVentaCocina = async (data) => {
    try {
        const response = await axiosInstance.post(`/${ventaCocina}/create`, data);
        showAlertExito("¡Éxito!", "Venta creada exitosamente");
        return response.data;
    } catch (error) {
        showAlertError("Error inesperado", "Ocurrió un problema, intenta más tarde.");
    }
};

// actualizar venta cocina
export const updateVentaCocina = async (id, data) => {
    try {
        const response = await axiosInstance.put(`/${ventaCocina}/edit/${id}`, data);
        showAlertExito("¡Éxito!", "Venta actualizada exitosamente");
        return response.data;
    } catch (error) {
        showAlertError("Error inesperado", "Ocurrió un problema, intenta más tarde.");
    }
};



/*******************  detalle de las mesas */
// listando detalle de las mesas
export const listDetalleMesas = async () => {
    try {
        const response = await axiosInstance.get(`/${ventaCocina}/mesas/list`);
        return response.data;
    } catch (error) {
        showAlertError("Error inesperado", "Ocurrió un problema, intenta más tarde.");
    }
};

// crear venta cocina
export const createVentaMesa = async (data) => {
    try {
        const response = await axiosInstance.post(`/${ventaCocina}/mesas/create`, data);
        showAlertExito("¡Éxito!", "Venta creada exitosamente");
        return response.data;
    } catch (error) {
        showAlertError("Error inesperado", "Ocurrió un problema, intenta más tarde.");
    }
};


// actualizar venta cocina
export const updateVentaMesa = async (id, data) => {
    try {
        const response = await axiosInstance.put(`/${ventaCocina}/mesas/edit/${id}`, data);
        showAlertExito("¡Éxito!", "Venta actualizada exitosamente");
        return response.data;
    } catch (error) {
        showAlertError("Error inesperado", "Ocurrió un problema, intenta más tarde.");
    }
};